import { usePinClientParamFirst } from './usePinClientParamFirst';
import { useStripTransientAuthParams } from './useStripTransientAuthParams';
import { useSyncClientFromQueryParam } from './useSyncClientFromQueryParam';
import { useSyncQueryParamFromClient } from './useSyncQueryParamFromClient';

/**
 * Keeps `?client=` and the active client context in sync. The client code lives
 * in the URL so it survives reloads and is shareable, so these steps write it
 * back — but that rewrite would also re-pin the Descope handshake params the
 * login redirect leaves behind (`code`, `descope-login-flow`), which are
 * single-use and belong to no one once login is done. So we strip those first.
 *
 * Steps 1-3 must run in order; the strip is order-independent (different keys,
 * idempotent):
 *   1. URL → context: switch the impersonated client when the URL changes.
 *   2. context → URL: write (or strip) `?client=` to match the active session.
 *   3. cosmetic: pin `?client=` first and upper-case it.
 */
export const useSyncClient = () => {
  useStripTransientAuthParams();
  useSyncClientFromQueryParam();
  useSyncQueryParamFromClient();
  usePinClientParamFirst();
};
